import type { TSiloOverview } from '~/types/silo/models'
import type { TMasterService } from '~/types/masterService/models'
import type { TMSService } from '~/types/msService/models'
import { assert } from '~/types/models'

const mn = `[cynqueModules/siloRelated/getAllMSServicesFromSiloOverview]`

export function getAllMSServicesFromSiloOverview({
  overviewData,
}: {
  overviewData: TSiloOverview
}) {
  const fn = `${mn} getAllMSServicesFromSiloOverview |`
  assert(
    'opportunity' in overviewData ||
      'order' in overviewData ||
      'company' in overviewData,
    `${fn} overviewData does not have an opportunity,` +
      ` order, or company property`
  )
  const siloRootEntityName =
    'opportunity' in overviewData
      ? 'opportunity'
      : 'order' in overviewData
      ? 'order'
      : 'company'
  const masterServicesPropertyName = `${siloRootEntityName}MasterServices`
  const msServicesPropertyName = `${siloRootEntityName}MSServices`
  assert(
    masterServicesPropertyName in overviewData,
    `${fn} ${siloRootEntityName}OverviewData has no` +
      ` ${siloRootEntityName}MasterServices property.` +
      ` It is malformed.`
  )
  const allMSServices: TMSService[] = overviewData[masterServicesPropertyName]
    .filter((ms: TMasterService) => !!ms[msServicesPropertyName])
    .map((ms: TMasterService) => ms[msServicesPropertyName])
    .flat()
  console.debug(`${fn} ${allMSServices?.length ?? 0} allMSServices`)
  return allMSServices ?? []
}
